import React from 'react';

import { TOpsClassDetailEx } from '../../../requests/opsRegistrationsExtra';
import { Card, labelClass } from '../ui';
import { fieldClass, TClassForm, TSetField } from './shared';

type Props = {
  form: TClassForm;
  set: TSetField;
  existing?: TOpsClassDetailEx;
};

/** Cost, payment type and terms; the deal's values show until overridden. */
const PaymentSection: React.FC<Props> = ({ form, set, existing }) => (
  <Card title="Payment Information">
    <div className="grid grid-cols-1 gap-4 p-5 md:grid-cols-2">
      <div>
        <label className={labelClass}>Course cost (USD)</label>
        <input
          type="number"
          min="0"
          step="0.01"
          className={fieldClass}
          value={form.cost}
          onChange={(e) => set('cost')(e.target.value)}
        />
      </div>
      <div>
        <label className={labelClass}>Payment type</label>
        <select
          className={fieldClass}
          value={form.paymentType}
          onChange={(e) => set('paymentType')(e.target.value)}
        >
          <option value="">
            {existing?.fromDeal?.paymentType
              ? `From the deal: ${existing.fromDeal.paymentType}`
              : '— from the deal —'}
          </option>
          {[
            'Invoice',
            'Partnership',
            'PrePaid (Different Opp)',
            'Purchase Order',
          ].map((t) => (
            <option key={t} value={t}>
              {t}
            </option>
          ))}
        </select>
      </div>
      {(form.paymentType || existing?.fromDeal?.paymentType || '').startsWith(
        'PrePaid',
      ) && (
        <div>
          <label className={labelClass}>Prepaid opportunity</label>
          <input
            className={fieldClass}
            placeholder="The opportunity that was prepaid"
            value={form.prepaidOpportunityId}
            onChange={(e) => set('prepaidOpportunityId')(e.target.value)}
          />
        </div>
      )}
      <div>
        <label className={labelClass}>Payment terms</label>
        <input
          className={fieldClass}
          placeholder="e.g. Net 30"
          value={form.paymentTerms}
          onChange={(e) => set('paymentTerms')(e.target.value)}
        />
      </div>
      {existing?.fromDeal?.paymentDetail && (
        <div className="md:col-span-2 text-xs text-gray-bold">
          Payment detail on the deal: {existing.fromDeal.paymentDetail}
        </div>
      )}
      <div className="md:col-span-2">
        <label className={labelClass}>Payment notes</label>
        <textarea
          className={fieldClass}
          rows={3}
          value={form.paymentNotes}
          onChange={(e) => set('paymentNotes')(e.target.value)}
        />
      </div>
    </div>
  </Card>
);

export default PaymentSection;
